<template>
    <el-dialog
      :title="title"
      v-if="showDialogForm"
      :visible.sync="showDialogForm"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
    >
      <div>
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          label-width="120px"
          margin-top="10px"
          margin-right="5px"
          :rules="rules"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="收费单号">
                <el-input v-model="dialogForm.feeData.paybillNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房产">
                <el-input v-model="dialogForm.feeData.roomName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="住户">
                <el-input v-model="dialogForm.feeData.payManName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="缴费时间">
                <el-input v-model="dialogForm.feeData.payTime" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收款人">
                <el-input v-model="dialogForm.feeData.cashierName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收款方式">
                <el-select
                  v-model="dialogForm.feeData.payType"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in payTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退款状态">
                <el-select
                  v-model="dialogForm.feeData.payStatus"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in payStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-divider content-position="left"><strong>收费明细</strong></el-divider>
            </el-col>
          </el-row>
          <div>
            <avue-crud
              ref="crud"
              :data="dialogForm.feeListData"
              :option="billOption"
              v-model="detailForm"
              class ="my-crud__pagination"
            >
              <template slot-scope="{ row }" slot="currentReturnAmount">
                <el-input
                  v-model="row.currentReturnAmount"
                  :ref="'return' + row.$index"
                  @blur="afterInputReturnAmount(row)"
                  :class="row.applyInputClassName"
                  :disabled="true"
                ></el-input>
              </template>
            </avue-crud>
          </div>
          <el-row style="margin-top: 0">
            <el-col :span="6">
              <el-form-item label="退款方式" prop="returnChannel">
                <el-select v-model="dialogForm.returnChannel" style="width: 100%">
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in returnChannelList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="本次总退费(元)" class="self-label">
                <el-input
                  v-model="applyAmount"
                  class="self-input-red"
                  ref="backingAmountInput"
                  :disabled="true"
                  @focus="blurThis('backingAmountInput')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="退款原因" prop="returnRemark">
                <el-input type="textarea" v-model="dialogForm.returnRemark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item style="margin-left: 70%">
              <el-button
                type="primary"
                :icon="submitBtnIcon"
                @click="applySubmit"
                style="width: 80px; height: 36px"
                >确认{{ counterLeft }}
              </el-button>
              <el-button
                icon="el-icon-close"
                @click="handleClose()"
                style="width: 80px; height: 36px; margin-left: 20px"
                >取消</el-button
              >
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
</template>

<script>
import { getDictionaryWithIntKey } from '../../../api/common';
import { getFeePayList, applyFeeReturn } from '@/api/v4ward/feereturn/feereturn-apply';

export default {
  name: 'feereturn-apply.vue',
  data() {
    return {
      submitBtnIcon: 'el-icon-check',
      title: '',
      applyAmount: '0',
      showDialogForm: false,
      payTypeList: [],
      returnChannelList: [],
      returnApplyList: [],
      payStatusList: [],
      billTableMinHeight: 104,
      dialogForm: {
        returnApply: 1,
        feeData: {},
        feeListData: [],
      },
      rules: {
        returnChannel: [{ required: true, message: '请选择退款方式', trigger: 'blur' }],
        returnRemark: [{ required: true, message: '请填写退费理由', trigger: 'blur' }],
      },
      billOption: {
        title: '',
        page: false,
        align: 'center',
        menuAlign: 'center',
        maxHeight: 104,
        menu: false,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        indexLabel: '序号',
        selection: false,
        stripe: true,
        border: true,
        tip: false,
        showSummary: true,
        sumColumnList: [
          {
            name: 'payAmount',
            type: 'sum',
          },
          {
            name: 'returnedAmount',
            type: 'sum',
          },
          {
            name: 'availableAmount',
            type: 'sum',
          },
          {
            name: 'currentReturnAmount',
            type: 'sum',
          },
        ],
        column: [
          {
            label: '收费类型',
            prop: 'paySort',
            type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=pay_sort',
          },
          {
            label: '费用名称',
            prop: 'itemsetName',
            overHidden: true,
            width: 230,
          },
          {
            label: '周期编码',
            prop: 'billcycleNo',
            width: 80,
          },
          {
            label: '账单起期',
            prop: 'billStartDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '账单止期',
            prop: 'billEndDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '缴费金额',
            prop: 'payAmount',
          },
          {
            label: '已退金额',
            prop: 'returnedAmount',
          },
          {
            label: '可退金额',
            prop: 'availableAmount',
          },
          {
            label: '本次退费',
            prop: 'currentReturnAmount',
            dataType: 'number',
            width: 140,
            slot: true,
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.initAllSelectionList();
  },
  methods: {
    enableSubmit(loading) {
      if (!loading) {
        this.submitBtnIcon = 'el-icon-check';
      } else {
        this.submitBtnIcon = 'el-icon-loading';
      }
    },
    applySubmit() {
      this.$refs.dialogForm.validate((valid) => {
        var t1 = window.setTimeout(this.enableSubmit, 15000);
        this.enableSubmit(true);
        if (valid) {
          if (this.checkApplyData()) {
            applyFeeReturn(this.dialogForm)
              .then(() => {
                this.$message.success('申请成功！');
                this.enableSubmit(false);
                this.$emit('closeApplyForm');
                this.handleClose();
              })
              .catch((err) => {
                this.enableSubmit(false);
              });
          } else {
            this.enableSubmit(false);
          }
        } else {
          //this.$message.warning('数据不合法！');
          this.enableSubmit(false);
        }
        window.clearTimeout(t1);
      });
    },
    checkApplyData() {
      if (this.applyAmount == '0') {
        this.$message.error('申请退款总金额为0！');
        return false;
      } else {
        return true;
      }
    },
    afterInputReturnAmount(rowData) {
      if (this.checkInputAmount(rowData)) {
        rowData.applyInputClassName = 'self-apply-amount-input';
      } else {
        rowData.applyInputClassName = 'self-apply-amount-input-error';
        rowData.currentReturnAmount = rowData.availableAmount;
      }
      this.calTotalReturnAmount();
    },
    checkInputAmount(rowData) {
      var currentReturnAmount = rowData.currentReturnAmount;
      if (0 === currentReturnAmount) return true;
      if (!currentReturnAmount) {
        this.$message.error('退款金额不能为空！');
        return false;
      } else if (isNaN(currentReturnAmount)) {
        this.$message.error('退款金额必须填数字！');
        return false;
      }
      var floatAmount = Math.round(parseFloat(currentReturnAmount) * 100) / 100;
      rowData.currentReturnAmount = floatAmount;
      if (floatAmount > rowData.availableAmount) {
        this.$message.error('退款金额不能大于可退款金额！');
        return false;
      }else if(floatAmount < 0 ){
        this.$message.error('退款金额不能小于0！');
        return false;
      }
      rowData.currentReturnAmount = floatAmount;
      return true;
    },
    getAmountInputClass(rowData) {
      return 'self-apply-amount-input';
    },
    openDialogForm(title, id) {
      this.title = title;
      this.showDialogForm = true;
      getFeePayList(id).then((data) => {
        data.data.returnChannel = null;
        this.dialogForm = data.data;
        this.dialogForm.feeListData.forEach((e) => {
          e.currentReturnAmount = e.availableAmount;
        });
        this.billOption.maxHeight =
          this.billTableMinHeight + 49 * this.dialogForm.feeListData.length;
        this.calTotalReturnAmount();

        this.returnChannelList.forEach((e) => {
          if (e.dictKey == '1' && this.dialogForm.feeData.payType == '1') {
            e.disabled = true;
          }else{
            e.disabled = false;
          }
        });
      });
    },
    initAllSelectionList() {
      getDictionaryWithIntKey('pay_type').then((data) => {
        this.payTypeList = data.data;
      });
      getDictionaryWithIntKey('return_channel').then((data) => {
        this.returnChannelList = data.data;
      });
      getDictionaryWithIntKey('return_apply').then((data) => {
        this.returnApplyList = data.data;
      });
      getDictionaryWithIntKey('pay_status').then((data) => {
        this.payStatusList = data.data;
      });
    },
    handleClose() {
      this.title = '';
      this.applyAmount = '0';
      this.showDialogForm = false;
      this.dialogForm = {
        feeData: {},
        feeListData: [],
      };
    },
    blurThis(refName) {
      this.$refs[refName].blur();
    },
    calTotalReturnAmount() {
      setTimeout(() =>{
        this.applyAmount = this.$refs.crud.sumsList[9].split(':')[1];
      });
    },
  },
};
</script>

<style scoped>
.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px solid #e8eaec;
}

.el-dialog__body .el-col {
  margin-bottom: 2px;
  margin-top: 2px;
}
.fee-return-dia .el-dialog__body {
  padding: 10px 60px 20px 50px;
}
.money-text-align .el-input--small .el-input__inner {
  text-align: center;
}
.avue-crud__menu {
  min-height: 10px;
}
.self-label .el-form-item__label {
  font-size: 14px;
}
.self-apply-amount-input input.el-input__inner {
  color: blue;
  font-size: 20px;
  background-color: #d9f3ed;
}
.self-apply-amount-input-error input.el-input__inner {
  color: red;
  font-size: 20px;
  background-color: #d9f3ed;
}
.self-input-red input.el-input__inner {
  color: red;
  font-size: 20px;
  background-color: #f3f3f3;
}
.my-crud__pagination > .avue-crud__pagination {
  position: relative;
  height: 0;
  margin-top: 0;
  margin-bottom: 15px !important;
  padding: 0 0;
}
</style>
